export const newDateFormat = (date) => {
    const pad = (n) => { return n < 10 ? "0" + n : n }
    return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
}

export const dateFormatFull = (date) => {
    const pad = (n) => { return n < 10 ? "0" + n : n }
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
}